export default __webpack_public_path__ + "static/media/no-profiles.d7abddd1.svg";